import React from "react";
import styles from "../../../../styles/pages/user/qcagentdashboard/verifidvideosdenied.module.scss";
import { Box } from "@mui/system";
import { Tab, Tabs, Typography } from "@mui/material";
import VerifiedVideoMenu from "../../../../components/VerifiedVideoMenu/VerifiedVideoMenu";
import TabArrow from "../../../../public/assets/icons/TabArrow";
import QcVerifyDeniedApproveRejectfilter from "../../../../components/QcVerifyDeniedApproveRejectfilter/QcVerifyDeniedApproveRejectfilter";
import QcVerifyDeniedApproveRejectTable from "../../../../components/QcVerifyDeniedApproveRejectTable/QcVerifyDeniedApproveRejectTable";
import QcVerifyDeniedApproveWebsiteFilter from "../../../../components/QcVerifyDeniedApproveWebsiteFilter/QcVerifyDeniedApproveWebsiteFilter";
import QcVerifyDeniedApproveWebsiteTable from "../../../../components/QcVerifyDeniedApproveWebsiteTable/QcVerifyDeniedApproveWebsiteTable";
import QcVerifyDeniedRejectedApproveFilter from "../../../../components/QcVerifyDeniedRejectedApproveFilter/QcVerifyDeniedRejectedApproveFilter";
import QcVerifyDeniedRejectedApprovedTable from "../../../../components/QcVerifyDeniedRejectedApprovedTable/QcVerifyDeniedRejectedApprovedTable";
import QcVerifyDeniedRejectedWebsiteFilter from "../../../../components/QcVerifyDeniedRejectedWebsiteFilter/QcVerifyDeniedRejectedWebsiteFilter";
import QcVerifyDeniedRejectedWebsiteTable from "../../../../components/QcVerifyDeniedRejectedWebsiteTable/QcVerifyDeniedRejectedWebsiteTable";
import QcVerifyDeniedWebsiteApprovedFilter from "../../../../components/QcVerifyDeniedWebsiteApprovedFilter/QcVerifyDeniedWebsiteApprovedFilter";
import QcVerifyDeniedWebsiteApprovedTable from "../../../../components/QcVerifyDeniedWebsiteApprovedTable/QcVerifyDeniedWebsiteApprovedTable";
import QcVerifyDeniedWebsiteRejectedFilter from "../../../../components/QcVerifyDeniedWebsiteRejectedFilter/QcVerifyDeniedWebsiteRejectedFilter";
import QcVerifyDeniedWebsiteRejectedTable from "../../../../components/QcVerifyDeniedWebsiteRejectedTable/QcVerifyDeniedWebsiteRejectedTable";
import QcDashboardWrapper from "../../../../layout/wrapper/QcDashboradWrapper";
import QcVerifiedVideoMenu from "../../../../components/QcVerifiedVideoMenu/QcVerifiedVideoMenu";
import QcVerifiedApprovedRejectedTab from "./QcVerifiedApprovedRejectedTab";
import QcVerifiedApprovedWebsiteTab from "./QcVerifiedApprovedWebsiteTab";
import QcVerifiedRejectedApprovedTab from "./QcVerifiedRejectedApprovedTab";
import QcVerifiedRejectedWebsiteTab from "./QcVerifiedRejectedWebsiteTab";
import QcVerifiedWebsiteApprovedTab from "./QcVerifiedWebsiteApprovedTab";
import QcVerifiedWebsiteRejectedTab from "./QcVerifiedWebsiteRejectedTab";

function CustomTabPanel(props) {
  const { children, value, index, ...other } = props;

  return (
    <div
      role="tabpanel"
      hidden={value !== index}
      id={`simple-tabpanel-${index}`}
      aria-labelledby={`simple-tab-${index}`}
      {...other}
    >
      {value === index && <>{children}</>}
    </div>
  );
}

function a11yProps(index) {
  return {
    id: `simple-tab-${index}`,
    "aria-controls": `simple-tabpanel-${index}`,
  };
}

export default function QcVerifiedVideosDenied() {
  const [value, setValue] = React.useState(0);

  const handleChange = (event, newValue) => {
    setValue(newValue);
  };

  /*************************************/

  const [anchorEl, setAnchorEl] = React.useState(null);
  const open = Boolean(anchorEl);
  const handleClick = (event) => {
    setAnchorEl(event.currentTarget);
  };
  const handleClose = () => {
    setAnchorEl(null);
  };

  return (
    <QcDashboardWrapper>
      <Box className={styles.reviewd_videos_wrapper}>
        <Box className={styles.reviewVideoMenu}>
          <QcVerifiedVideoMenu />
        </Box>

        <Box className={styles.video_tab}>
          <Tabs
            value={value}
            onChange={handleChange}
            aria-label="basic tabs example"
          >
            <Tab
              label={
                <>
                  <Box className={styles.tabItem}>
                    <Typography variant="caption">Approved</Typography>
                    <figure>
                      <TabArrow />
                    </figure>
                    <Typography variant="caption">Rejected</Typography>
                  </Box>
                </>
              }
              {...a11yProps(0)}
            />
            <Tab
              label={
                <>
                  <Box className={styles.tabItem}>
                    <Typography variant="caption">Approved</Typography>
                    <figure>
                      <TabArrow />
                    </figure>
                    <Typography variant="caption">Website Only</Typography>
                  </Box>
                </>
              }
              {...a11yProps(1)}
            />
            <Tab
              label={
                <>
                  <Box className={styles.tabItem}>
                    <Typography variant="caption">Rejected</Typography>
                    <figure>
                      <TabArrow />
                    </figure>
                    <Typography variant="caption">Approved</Typography>
                  </Box>
                </>
              }
              {...a11yProps(2)}
            />
            <Tab
              label={
                <>
                  <Box className={styles.tabItem}>
                    <Typography variant="caption">Rejected</Typography>
                    <figure>
                      <TabArrow />
                    </figure>
                    <Typography variant="caption">Website Only</Typography>
                  </Box>
                </>
              }
              {...a11yProps(3)}
            />
            <Tab
              label={
                <>
                  <Box className={styles.tabItem}>
                    <Typography variant="caption">Website Only</Typography>
                    <figure>
                      <TabArrow />
                    </figure>
                    <Typography variant="caption">Approved</Typography>
                  </Box>
                </>
              }
              {...a11yProps(4)}
            />
            <Tab
              label={
                <>
                  <Box className={styles.tabItem}>
                    <Typography variant="caption">Website Only</Typography>
                    <figure>
                      <TabArrow />
                    </figure>
                    <Typography variant="caption">Rejected</Typography>
                  </Box>
                </>
              }
              {...a11yProps(5)}
            />
          </Tabs>
        </Box>

        <Box className={styles.reviewVideoTabMain}>
          <CustomTabPanel value={value} index={0}>
            <Box className={styles.single_rreview_tab}>
              <QcVerifiedApprovedRejectedTab />
            </Box>
          </CustomTabPanel>

          <CustomTabPanel value={value} index={1}>
            <Box className={styles.single_rreview_tab}>
              <QcVerifiedApprovedWebsiteTab />
            </Box>
          </CustomTabPanel>

          <CustomTabPanel value={value} index={2}>
            <Box className={styles.single_rreview_tab}>
              <QcVerifiedRejectedApprovedTab />
            </Box>
          </CustomTabPanel>

          <CustomTabPanel value={value} index={3}>
            <Box className={styles.single_rreview_tab}>
              <QcVerifiedRejectedWebsiteTab />
            </Box>
          </CustomTabPanel>

          <CustomTabPanel value={value} index={4}>
            <Box className={styles.single_rreview_tab}>
              <QcVerifiedWebsiteApprovedTab />
            </Box>
          </CustomTabPanel>

          <CustomTabPanel value={value} index={5}>
            <Box className={styles.single_rreview_tab}>
              {/* <Box className={styles.reviewd_filter_wrap}>
                <QcVerifyDeniedWebsiteRejectedFilter />
              </Box>

              <Box className={styles.approved_videos_table_wrap}>
                <QcVerifyDeniedWebsiteRejectedTable />
              </Box> */}
              <QcVerifiedWebsiteRejectedTab />
            </Box>
          </CustomTabPanel>
        </Box>
      </Box>
    </QcDashboardWrapper>
  );
}
